import { combineReducers } from 'redux';

import { filters } from '@zoopla/redux-reducer-filters';
import { listingsSortOrder } from '@zoopla/redux-reducer-sort-order';
import { searchResults } from '@zoopla/redux-reducer-search-results';

export const rootReducer = combineReducers({
    filters,
    listingsSortOrder,
    searchResults
});
